module.exports = __webpack_public_path__ + "img/6.a11b1e1d.jpg";